import { DefaultButton, PrimaryButton } from "@fluentui/react";
import Moment from "moment";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import styles from "../Hospital/hospital.module.css";
import { ACTIONS, AuthRoutes, USERTYPES } from "../../constants/Constants";
import { getEnv } from "../../helpers/EnvHelper";
const ColumnsClient = (handleClickGroup, userRole) => {
  const [t, i18n] = useTranslation();
  // const childTrPadding =
  //   getEnv("REACT_APP_HYBRID_MODE") == "false" ? "15px 5px" : "15px 10px";

    const childTrPadding = (getEnv("REACT_APP_HYBRID_MODE") == "false") ? "15px 0px 15px 10px" : "15px 10px";
    const rowTrPadding = "0px 10px";

  return [
    {
      id: "firmname",
      style: { width: "15vw", boxSizing:'border-box',padding:rowTrPadding },
      headerStyle: { padding: "15px 0px 15px 10px", textAlign: "left",boxSizing:'border-box' },
      headerClass: "break-word column-user-details-header",
      classChildName: "break-word cursor-pointer",
      header: () => <span className="">Name</span>,
      accessor: "projects",
      accessorKey: "projects",
      show: true,
      cell: (cell) => (
        <>
          <div>
            <div className="user-heading">Name</div>
            <div className="user-sub-heading">{cell.row.original.name.replace(/^(\__p_)/, "")}</div>
          </div>

        </>
      ),
    },
    {
      id: "description",
      style: { width: "20vw", boxSizing:'border-box',padding:rowTrPadding },
      headerStyle: {
        padding: childTrPadding,
        textAlign: "left",
        width: "20vw !important",
        boxSizing:'border-box'
      },
      headerClass: "break-word column-user-contact-header",
      classChildName: "break-word cursor-pointer column-user-contact-header",
      header: () => <span className="">Description</span>,
      accessor: "description",
      accessorKey: "description",
      show: true,
       cell: (cell) => (
        <>
          <div>
            <div className="user-heading">Description</div>
            <div className="user-sub-heading">{cell.row.original.address}</div>
          </div>

        </>
      ),
    },
  ];
};
export default ColumnsClient;
